module.exports = " <div class=imgUpload _v-fb51e1ba=\"\"> <img class=imgsize :src=img alt=\"\" v-show=\"img.length > 0\" _v-fb51e1ba=\"\"> <p v-else=\"\" _v-fb51e1ba=\"\">{{tips}}</p> <div class=file-layout _v-fb51e1ba=\"\"><input type=file id={{fileID}} _v-fb51e1ba=\"\"></div> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-fb51e1ba!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Imgupload.vue
 ** module id = 94
 ** module chunks = 0
 **/